import { CourseApi, coursesApi } from "api";
import { PaziaFormButton, PaziaSwitch } from "components/atoms";
import { PaziaModal } from "components/molecules";
import { yupResolver } from "@hookform/resolvers/yup";
import React from "react";
import { FormProvider, useForm } from "react-hook-form";
import * as yup from "yup";
import { useToaster } from "utils";
import { ModalPadding } from "../Modals/ModalPadding";
import { ModalHeader } from "../Modals/ModalHeader";

interface DuplicateCourseModalProps {
  onCloseRequest: () => void;
  onSuccessDuplicate: (course: CourseApi) => void;
  courseId: number | null;
}

export const DuplicateCourseModal = ({ onCloseRequest, onSuccessDuplicate, courseId }: DuplicateCourseModalProps) => {
  const { showSuccess, showError } = useToaster();
  const methods = useForm<DuplicateCourseValues>({
    resolver: yupResolver(duplicateCourseSchema),
  });

  const { handleSubmit } = methods;

  const onSubmit = async (data: DuplicateCourseValues) => {
    try {
      const response = await coursesApi.duplicate(courseId!, data);
      onSuccessDuplicate(response.data);
      onCloseRequest();
      showSuccess("Kurs został zduplikowany");
    } catch (e) {
      console.error(e);
      showError("Wystąpił błąd podczas duplikowania kursu");
    }
  };

  return (
    <PaziaModal id="duplicate-course-modal" onCloseRequest={onCloseRequest} isOpen={courseId != null}>
      {courseId && (
        <ModalPadding>
          <ModalHeader>Duplikowanie kursu</ModalHeader>
          <div className="py-2">Wybierz elementy kursu, które chcesz zduplikować.</div>
          <FormProvider {...methods}>
            <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-2">
              <PaziaSwitch name={FORM_FIELDS.SCHEDULE} label="Harmonogram" />
              <PaziaSwitch name={FORM_FIELDS.EXAMS} label="Egzaminy" />
              <PaziaSwitch name={FORM_FIELDS.PAYMENTS} label="Płatności" />
              <PaziaSwitch name={FORM_FIELDS.DOCUMENTS} label="Dokumenty" />
              <PaziaSwitch name={FORM_FIELDS.FORM} label="Formularz zgłoszeniowy" />

              <PaziaFormButton title="Duplikuj" />
            </form>
          </FormProvider>
        </ModalPadding>
      )}
    </PaziaModal>
  );
};

export const FORM_FIELDS = {
  SCHEDULE: "schedule",
  EXAMS: "exams",
  PAYMENTS: "payments",
  DOCUMENTS: "documents",
  FORM: "form",
} as const;

export const duplicateCourseSchema = yup
  .object({
    [FORM_FIELDS.SCHEDULE]: yup.boolean().default(false).required(),
    [FORM_FIELDS.EXAMS]: yup.boolean().default(false).required(),
    [FORM_FIELDS.PAYMENTS]: yup.boolean().default(false).required(),
    [FORM_FIELDS.DOCUMENTS]: yup.boolean().default(false).required(),
    [FORM_FIELDS.FORM]: yup.boolean().default(false).required(),
  })
  .required();

export type DuplicateCourseValues = yup.InferType<typeof duplicateCourseSchema>;
